import { AxiosResponse } from 'axios'
import {
  PermissionScenarios,
  PermissionRule,
  ApiResult,
  PermissionCheckResultsModel,
  PermissionCheckRequest,
} from '../api'
import { useApiClient } from './useApiClient'

export type PermissionMapping = {
  [key in PermissionScenarios]: PermissionRule
}

export const usePermissionApi = () => {
  const apiClient = useApiClient()

  const canAccessDocument = (request: PermissionCheckRequest) => {
    return apiClient.request<
      void,
      AxiosResponse<ApiResult<PermissionCheckResultsModel>>
    >({
      url: `api/permissions/checkPermissions`,
      method: 'post',
      data: request,
      withCredentials: true,
    })
  }

  return {
    canAccessDocument,
  }
}
